import {
  resetCreateFavoriteListAndAddRestaurantToFavoriteList,
  userFavoriteListState,
} from "@/store/userFavoriteListState";

import { useEffect, useState, type FC } from "react";
import CreateFavoriteList from "./components/CreateFavoriteList";
import FavoriteList from "./components/FavoriteList";
import { Drawer, DrawerContent } from "@/components/ui/drawer";

type Props = {
  open: boolean;
  onClose: () => void;
  restaurantsId: string[];
};

const DrawerAddRestaurantToFavorite: FC<Props> = ({
  open,
  onClose,
  restaurantsId,
}) => {
  const {
    data: favoriteListRestaurants,
    addingRestaurantToFavoriteList,
    addedRestaurantToFavoriteList,
  } = userFavoriteListState();

  const favoriteList = favoriteListRestaurants
    ? Object.values(favoriteListRestaurants).map(
        (favoriteRestaurant) => favoriteRestaurant.favorite,
      )
    : [];

  const [createNewFavorite, setCreateNewFavorite] = useState(false);

  useEffect(() => {
    if (addedRestaurantToFavoriteList) {
      onClose();
    }

    return () => {
      setCreateNewFavorite(false);
      resetCreateFavoriteListAndAddRestaurantToFavoriteList();
    };
  }, [addedRestaurantToFavoriteList]);

  return (
    <Drawer
      open={open}
      onClose={() => {
        onClose();
        setCreateNewFavorite(false);
      }}
    >
      <DrawerContent>
        {(favoriteList && favoriteList.length === 0) || createNewFavorite ? (
          <CreateFavoriteList
            onClose={() => {
              onClose();
              setCreateNewFavorite(false);
            }}
            isLoading={addingRestaurantToFavoriteList}
            restaurantsId={restaurantsId}
          />
        ) : (
          <FavoriteList
            onClose={() => {
              onClose();
              setCreateNewFavorite(false);
            }}
            isLoading={addingRestaurantToFavoriteList}
            restaurantsId={restaurantsId}
            setCreateNewFavorite={setCreateNewFavorite}
            favoriteList={favoriteList}
          />
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerAddRestaurantToFavorite;
